import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';
import {isOk} from '../utils/apiResponse';
import {LearnApi} from './learnApi';

// Capa API de «Aprende Dashbo» que usa la pantalla de Usuarios (contrato §2 de la tanda
// 2026-10-03-aprende-dashbo). `learning/me/` lo lee el cliente de la página (`learnApi.js`), con su
// cache compartido; acá vive lo que es sólo del equipo.
//
// Las rutas cuelgan de `learning/`, nunca de `agency/team/…`: `^agency/team` está declarado sin `$`
// en el backend y se come cualquier ruta que empiece igual.
//
// Todas responden con `OKResponse` (`{status: 'OK', data}`); cualquier otro `status` es un error.
// Un usuario que no es Admin recibe el 404 uniforme en `learning/team/*`.

export const LearnTeamApi = {
    /**
     * `{enabled, isAdmin}` de quien mira, o `null` si no se pudo leer. Comparte el pedido (y la copia
     * de 30 s) con la entrada del menú y el lanzador del riel.
     */
    getAccess() {
        return LearnApi.getMe().then((response) => {
            if (!isOk(response) || !response.data) return null;
            return {enabled: response.data.enabled === true, isAdmin: response.data.is_admin === true};
        });
    },

    /** El avance del equipo (sólo Admin). Devuelve la respuesta cruda: quien llama decide el error. */
    getTeam() {
        return new APIClient(`${API_URL}learning/team/`).call('GET');
    },

    /** «Recordarle»: un aviso por persona cada 7 días; antes de eso, `NUDGE_TOO_SOON`. */
    nudge(userId) {
        return new APIClient(`${API_URL}learning/team/${encodeURIComponent(userId)}/nudge/`).call('POST', {});
    },
};
